import { App, Plugin } from "vue";
import { useI18n } from "@/hooks/i18n";
export const translate: Plugin = function (app: App) {
  app.config.globalProperties.$translate = useI18n().i18n.global.t;
};
